import { BlockType } from '../../Block/Block';
import { transformToDefaultBlock } from '../../Block/BlockTransformers';
import { AnchorTargetInterface, AnchorTargetResource } from './AnchorTarget';

export const transformToAnchorTarget = (resource: AnchorTargetResource): AnchorTargetInterface => {
    const defaultBlock = transformToDefaultBlock(resource);

    return {
        ...defaultBlock,
        type: BlockType.anchorTarget,
        anchorId: resource.anchorId,
    };
};
